module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mn-7e8cb1adbf6802735a51e1781cf1a7fc.svg";